var CONST = {
    WRAPPER_CLASS: 'acp-hts-wrapper',
    OVERFLOW_CLASS: '-overflow',
    MORE_CLASS: '-more',
    LESS_CLASS: '-less'
};
var TableWrapper = /** @class */ (function () {
    function TableWrapper(table) {
        this.enabled = false;
        this.table = table;
        this.wrapper = null;
        this.initEvents();
    }
    TableWrapper.prototype.enable = function () {
        this.enabled = true;
        this.checkWrapperState();
    };
    TableWrapper.prototype.disable = function () {
        this.enabled = false;
    };
    TableWrapper.prototype.initEvents = function () {
        var _this = this;
        this.table.addEventListener('scroll', function () {
            _this.checkWrapperState();
        });
        window.addEventListener('resize', function () {
            clearTimeout(_this.timeout);
            _this.timeout = setTimeout(function () {
                _this.checkWrapperState();
            }, 100);
        });
    };
    TableWrapper.prototype.wrap = function () {
        if (this.table.parentElement.classList.contains(CONST.WRAPPER_CLASS)) {
            return;
        }
        this.wrapper = document.createElement('div');
        this.wrapper.classList.add(CONST.WRAPPER_CLASS);
        this.table.parentNode.insertBefore(this.wrapper, this.table);
        this.wrapper.appendChild(this.table);
    };
    TableWrapper.prototype.setOffset = function (percentage) {
        var scrollableAreaWidth = this.table.scrollWidth - this.table.offsetWidth;
        var offsetX = (scrollableAreaWidth * (percentage / 100));
        this.table.scrollLeft = Math.round(offsetX);
    };
    TableWrapper.prototype.getOffsetPercentage = function () {
        var scrollableAreaWidth = this.table.scrollWidth - this.table.offsetWidth;
        var offset = this.table.scrollLeft;
        var percentage = (offset / scrollableAreaWidth) * 100;
        return Math.round(percentage);
    };
    TableWrapper.prototype.checkWrapperState = function () {
        if (!this.enabled) {
            return;
        }
        var total = this.table.scrollWidth;
        var width = this.table.offsetWidth;
        var scrollLeft = this.table.scrollLeft;
        this.wrapper.classList.remove(CONST.LESS_CLASS, CONST.MORE_CLASS, CONST.OVERFLOW_CLASS);
        if (total > width) {
            this.wrapper.classList.add(CONST.OVERFLOW_CLASS);
            if (scrollLeft + width + 10 < total) {
                this.wrapper.classList.add(CONST.MORE_CLASS);
            }
            if (scrollLeft > 0) {
                this.wrapper.classList.add(CONST.LESS_CLASS);
            }
        }
    };
    return TableWrapper;
}());
export default TableWrapper;
